module.exports = "query GetAddPaymentSettingsDailyCap {\n  account {\n    addPaymentSettingsDailyCap {\n      available\n      cap\n    }\n  }\n}\n"